import { render } from "./NorthArrow.vue?vue&type=template&id=54038c92&scoped=true"
import script from "./NorthArrow.vue?vue&type=script&lang=js"
export * from "./NorthArrow.vue?vue&type=script&lang=js"

import "./NorthArrow.vue?vue&type=style&index=0&id=54038c92&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54038c92"]])

export default __exports__